import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" マイページに戻る ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_InternalServerError = _resolveComponent("InternalServerError")!

  return (_openBlock(), _createBlock(_component_InternalServerError, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseButton, {
        buttonClass: "outlined",
        class: "mt-5",
        onClick: _ctx.handleGoMyPage
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
}